@if (!isPinned()) {
  <div
    class="pin-wrapper"
    (click)="handlePinClick($event)"
    [ngClass]="{
      visible: hovering,
      pinned: false,
      done: false,
      message: isMessage,
    }"
  >
    <i class="tio-pin"></i>
  </div>
} @else {
  <div
    class="btn-group"
    dropdown
    #dropdown="bs-dropdown"
    placement="bottom right"
    [insideClick]="true"
    [autoClose]="true"
    container="body"
  >
    <div
      class="pin-wrapper"
      (click)="handlePinClick($event)"
      dropdownToggle
      [ngClass]="{
        visible: hovering || isPinned(),
        pinned: isPinned(),
        done: pin?.pinned_status === 2 || model?.pinned === 'completed',
        message: isMessage,
      }"
    >
      <i class="tio-pin"></i>
      @if (showAssignedTo) {
        <ds-avatar
          *ngIf="pin?.assigned_to != null"
          size="md"
          [name]="pin.assigned_to.full_name"
          [image]="pin.assigned_to.pictureUrl"
        />
      }
    </div>
    <div
      id="dropdown-alignment"
      *dropdownMenu
      class="dropdown-menu dropdown-menu-right dropdown-pin"
      role="menu"
      aria-labelledby="button-alignment"
    >
      <div class="dropdown-title">CHANGE STATUS</div>
      <div class="change-status">
        @if (pin?.pinned_status === PINNED_STATUS_CHOICES.DONE) {
          <div
            class="pin-pill todo"
            (click)="updatePinStatus(PINNED_STATUS_CHOICES.TODO)"
          >
            <i class="tio-pin"></i> TO-DO
          </div>
        }
        @if (pin?.pinned_status === PINNED_STATUS_CHOICES.TODO) {
          <div
            class="pin-pill done"
            (click)="updatePinStatus(PINNED_STATUS_CHOICES.DONE)"
          >
            <i class="tio-pin"></i> DONE
          </div>
        }
        <div class="pin-pill unpin" (click)="deletePin()">
          <i class="tio-pin"></i> UNPIN
        </div>
      </div>
      @if (showAssignedTo) {
        <hr />
        <div class="dropdown-title">WHO NEEDS TO TAKE ACTION?</div>
        <ng-template #customItemTemplate let-model="item" let-index="index">
          <div class="d-flex align-items-center gap-2">
            <ds-avatar
              size="md"
              [name]="model.full_name"
              [image]="model.pictureUrl"
            />
            {{ model.full_name }}
          </div>
        </ng-template>
        <div class="typeahead-wrapper">
          <input
            [(ngModel)]="selectedUser.full_name"
            [typeahead]="
              availableStaff || currentWorkspaceService.availableStaff
            "
            typeaheadOptionField="full_name"
            [typeaheadScrollable]="true"
            [typeaheadOptionsInScrollableView]="5"
            [typeaheadOptionsLimit]="9999"
            [typeaheadMinLength]="0"
            [typeaheadItemTemplate]="customItemTemplate"
            (typeaheadOnSelect)="updatePinAssignee($event)"
            (focus)="focus($event)"
            (blur)="blur($event)"
            class="form-control chevron"
            container="body"
            style="margin-bottom: 10px"
          />
        </div>
      }
    </div>
  </div>
}
